const MAX_ELEMENTS_PER_HIT = 10;
/**
 * according to GTM docs, the limit is 200 for ecommerce hits
 * @link https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pl&client_type=gtag
 */
const MAX_ELEMENTS_PER_ECOMMERCE_HIT = 200;

export interface IGtmData {
    event: string;
    button?: string;
    ecommerce?: {
        [key: string]: object[] | unknown;
        checkout?: unknown;
        currencyCode?: unknown;
        impressions?: object[];
        purchase?: unknown;
        items?: object[];
        item_list_id?: string;
        item_list_name?: string;
    };
    action?: string;
    label?: string | number;
}

export const hitGoogleTagManager = <GtmData extends IGtmData>(gtmData: GtmData) => {
    const win = window as Window;

    win.dataLayer = win.dataLayer || [];
    const chunkDataAndPush = (key: string, maxElementsPerHit = MAX_ELEMENTS_PER_HIT) => {
        const elements = gtmData.ecommerce?.[key];
        if (Array.isArray(elements) && elements?.length > maxElementsPerHit) {
            const chunks = Math.ceil(elements.length / maxElementsPerHit);
            for (let i = 0; i < chunks; ++i) {
                const chunkData = structuredClone(gtmData);
                chunkData.ecommerce![key] = elements.slice(i * maxElementsPerHit, (i + 1) * maxElementsPerHit);
                win.dataLayer.push(chunkData);
            }
        } else {
            win.dataLayer.push(gtmData);
        }
    };

    // need to chunk elements bcs of GTM limit
    if ((gtmData.ecommerce?.impressions?.length ?? 0) > MAX_ELEMENTS_PER_HIT) {
        chunkDataAndPush("impressions");
    } else if ((gtmData.ecommerce?.items?.length ?? 0) > MAX_ELEMENTS_PER_ECOMMERCE_HIT) {
        chunkDataAndPush("items", MAX_ELEMENTS_PER_ECOMMERCE_HIT);
    } else {
        win.dataLayer.push(gtmData);
    }
};
